import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IBaseBusinessRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessRepository';

/**
 * 取引情報のメモを削除するユースケース
 * @class DeleteBusinessMemoUseCase
 */
export class DeleteBusinessMemoUseCase {
  private repository: IBaseBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 取引情報のリポジトリ
   */
  constructor(repository: IBaseBusinessRepository) {
    this.repository = repository;
  }

  /**
   * メモを削除する
   * @param businessId - 取引ID
   * @returns 結果オブジェクト
   */
  async Execute(businessId: string): Promise<INetworkResult<string, Error>> {
    try {
      const result = await this.repository.deleteBaseBusinessMemo(businessId);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
